import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { combineLatest, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { NbDialogService, NbSidebarService } from '@nebular/theme';
import { ExcelService } from '../../../@core/data/file-export/file-export.service';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { OrcsService } from '../../../@core/data/orcs/orcs.service';
import { ClientService } from '../../../@core/data/clients/client.service';
import { UserService } from '../../../@core/data/user/user.service';
import { LayoutService } from '../../../@core/utils';
import { NbToastrService } from '@nebular/theme';
import { ToastrConfigs } from "../../../@core/data/toastr-config";
import { ConfirmActionModalComponent } from '../../clients/confirm-action-modal/confirm-action-modal.component';
import { getLoggedUser, getUsers } from "../../../store/users/users.selectors";
import { Store } from "@ngrx/store";
import { IAppState } from "../../../store/app.state";
import { getTeams } from "../../../store/teams/teams.selectors";
import { TeamAddRequested, TeamAddSuccess, TeamDeleteRequested, TeamUpdateRequested, TeamUpdateSuccess } from '../../../store/teams/teams.actions';
import { Actions, ofType } from '@ngrx/effects';
import { ChangeDetectorRef } from '@angular/core';
const _ = require('lodash');


@Component({
  selector: 'ngx-view-team',
  templateUrl: './view-team.component.html',
  styleUrls: ['./view-team.component.scss']
})
export class ViewTeamComponent implements OnInit {

  @ViewChild('searchInput', { static: false }) searchElement: ElementRef;
  @ViewChild('scroll', { static: false }) scroll: ElementRef;

  showNewTeamForm: boolean = false;
  isSpinnerActive: boolean = false;
  filtersEnabled = false;
  newClient = false;
  filter = {
    search: '',
    status: -1
  };
  sort = {
    column: '',
    order: 'DESC'
  };
  public teams: any = [];
  public clients: any = [];
  public users: any = [];
  public usersForAutocomplete: any = [];
  // public canSaveNewPayment = false;
  public statuses = {
    '2': 'In asteptare client',
    '1': 'In lucru',
    '3': 'Depus, in solutionare',
    '4': 'Dosar eliberat',
    '5': 'Documente predate client',
    '6': 'Amanat',
    '7': 'Dosar spre eliberare'
  };
  departmentColors = {
    'CONTABILITATE': '#90EE90', 
    'HR': '#ffdab9',           
    'IT': '#FF8888',           
    'JURIDIC': '#D8BFD8',
    'MANAGEMENT': '#F0FD82',
    'FORMARE PROFESIONALA': '#FFB6C1', 
    'FONDURI EU': '#add8e6'   
  };
  defaultColor = '#ffffff';

  public starttimeInterval; // = new Date();
  public endtimeInterval; // = new Date();
  public isOneLineInEditMode = false;

  columns = [];

  public isMovePortofolioActivated = false;
  public month = `${moment().month()}`;
  public year = `${moment().year()}`;
  public search: string = '';
  searchUpdate = new Subject<string>();
  public formGroup: FormGroup;
  public formGroupMovePortofolio: FormGroup;
  public userId;
  public user: any = {};
  public newMembers: any = [];
  private teamsSubscription: Subscription;
  public subject = new Subject();

  constructor(private orcService: OrcsService,
    private userService: UserService,
    private clientService: ClientService,
    private dialogService: NbDialogService,
    private excelService: ExcelService,
    private cookieService: CookieService,
    private router: Router,
    private sidebarService: NbSidebarService,
    private layoutService: LayoutService,
    private fb: FormBuilder,
    private toastrService: NbToastrService,
    private store: Store<IAppState>,
    private actions$: Actions,
    private cdr: ChangeDetectorRef
  ) {

    this.userId = localStorage.getItem('userId') || this.cookieService.get('UserId');
    this.store.select(getLoggedUser).pipe(takeUntil(this.subject)).subscribe((user) => {
      if (!user?.user_id) return;
      this.user = { ...user };
      this.user.canViewTeams = this.user?.actions?.some(action => action.action_id == AsconActions.ViewTeams);
      this.user.canRegisterTeam = this.user?.actions?.some(action => action.action_id == AsconActions.RegisterTeam);
      this.user.canUpdateTeam = this.user?.actions?.some(action => action.action_id == AsconActions.UpdateTeam);
      this.user.canDeleteTeam = this.user?.actions?.some(action => action.action_id == AsconActions.DeleteTeam);
      if (!this.user?.canViewTeams) {
        this.router.navigate(['pages/clients/view-clients']);
      }
      this.getUsers();
      this.initForm({}, []);
    });

    this.searchUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        this.filter.search = value;
        this.filtersEnabled = true;
        this.getTeams(false);
      });
  }

  ngOnDestroy () {
    this.subject.next();
  }

  initForm(team, teamMembers) {
    this.formGroup = new FormGroup({
      id: new FormControl(team.id),
      name: new FormControl(team.name, Validators.required),
      leader: new FormControl(team.lead),
      members: new FormControl(teamMembers),
      isconta: new FormControl(team.isconta === '1' ? true : false),
      isit: new FormControl(team.isIt === '1' ? true : false),
      departament: new FormControl(team.departament),
    });
  }

  set leader(id) {
    this.formGroup.controls.leader.setValue(id);
  }

  set userFrom(id) {
    this.formGroupMovePortofolio.controls.userFrom.setValue(id);
  }

  set userTo(id) {
    this.formGroupMovePortofolio.controls.userTo.setValue(id);
  }

  initFormMovePortofolio() {
    this.formGroupMovePortofolio = new FormGroup({
      userFrom: new FormControl('', Validators.required),
      userTo: new FormControl('', Validators.required)
    });
  }


  
  ngOnInit() {
    this.listenForTeamAddUpdateSuccess();
    this.columns = [
      {
        name: 'Actiuni',
        class: 'orc-action h-100',
        sortable: false,
        enabled: true
      },
      {
        name: 'Departament',
        class: 'institution-issue-date h-100',
        sortable: true,
        sortKey: 'departament',
        enabled: true
      },
      {
        name: 'Nume',
        class: 'institution-issue-date h-100',
        sortable: true,
        sortKey: 'name',
        enabled: true
      },
      {
        name: 'Sef echipa',
        class: 'institution-issue-date h-100',
        sortable: true,
        sortKey: 'leader',
        enabled: true
      },
      {
        name: 'Nr. membri',
        class: 'orc-reg-number-orc h-100',
        sortable: true,
        sortKey: 'registration_number',
        enabled: true
      },
      {
        name: 'Membri',
        class: 'orc-date h-100',
        sortable: false,
        sortKey: 'admission_date',
        enabled: true
      },
     
    ];
    this.columns = this.columns.filter(c => c.enabled);
  }

  getDepartmentColor(departament: string): string {
    return this.departmentColors[departament] || this.defaultColor;
  }

  getDepartments(): any[] {
    return [...new Set(this.teams.map(team => team.departament))];
  }

  getTeamsByDepartment(department: string): any[] {
    return this.teams.filter(team => team.departament === department);
  }

  toggleNewClient() {
    this.newClient = !this.newClient;

    if (this.newClient) {
      this.formGroup.controls['newClient'].setValidators([Validators.required]);
      this.formGroup.controls['client'].setValidators([]);
      this.formGroup.controls['client'].setValue(null);
    } else {
      this.formGroup.controls['client'].setValidators([Validators.required]);
      this.formGroup.controls['newClient'].setValidators([]);
      this.formGroup.controls['newClient'].setValue(null);
    }
  }

  resetfilters() {
    this.filtersEnabled = false;
    this.filter = {
      search: '',
      status: -1
    };
    this.starttimeInterval = null;
    this.endtimeInterval = null;
    //this.getTeams();
  }

  onDestory() {

    if (this.subject) {
      this.subject.next();
      this.subject.complete();
    }
  }

  listenForTeamAddUpdateSuccess() {

    this.actions$.pipe(
      ofType(TeamAddSuccess)
    ).subscribe(({ team }) => {
      this.initForm({}, []);
      
      this.showNewTeamForm = false;
      setTimeout(() => {
        this.sortTeams(null, true);
        this.isSpinnerActive = false;
        this.cdr.detectChanges();
      }, 500);

    });

    this.actions$.pipe(
      ofType(TeamUpdateSuccess)
    ).subscribe(({ team }) => {
      this.isOneLineInEditMode = false;
   
      this.initForm({}, []);
      this.updateCoordinatorForClients(team, team);

      this.showNewTeamForm = false;
      setTimeout(() => {
        this.sortTeams(null, true);
        this.isSpinnerActive = false;
        this.cdr.detectChanges();
      }, 500);
    });
  }

  getTeams(state = false) {
    this.isSpinnerActive = true;
    combineLatest([
      this.store.select(getTeams),
      this.store.select(getUsers)
    ])
    .pipe(takeUntil(this.subject))
    .subscribe(([teams, users]) => {
      if (!teams || !users) return;
      this.teams = [...teams];
      const updatedTeams = this.teams.map(team => {
       
        const teamCopy = { ...team };
        const user = users.find(u => u.user_id === teamCopy.lead);
        teamCopy.membersName = teamCopy.members.map(m => m.fullname).join(', ');
        teamCopy.leaderName = user ? user.fullname : '';
        return teamCopy;
      });

      this.teams = updatedTeams;

      this.sortTeams(null, state);
      this.isSpinnerActive = false;
    });
    this.cdr.detectChanges();
  }

  getMaxTeamMembers(departament): number {
    const departmentTeams = this.teams.filter(team => team.departament === departament);
    return Math.max(...departmentTeams.map(team => team.members.length), 0);
  }

  getArrayForTeamMembers(departament): number[] {
    const maxMembers = this.getMaxTeamMembers(departament);
    return Array.from({ length: maxMembers }, (_, index) => index);
  }

  getUsers() {
    const data = this.userService.getAllUsers();

    data.subscribe((usersResponse: any) => {
      this.users = usersResponse.data;
      this.usersForAutocomplete = this.users.map(user => ({id: user.user_id, name: user.fullname}));
      this.getTeams();
    });
  }

  addTeam() {
    this.showNewTeamForm = true;
    const scrl: any = this.scroll;
    scrl.scrollToPosition(-75);
  }

  cancelNewTeam() {
    this.initForm({}, []);
    this.showNewTeamForm = false;
  }

  sortTeams(column, noChangesInSort) {
    if (noChangesInSort) {
      this.teams = _.orderBy([].concat(this.teams || []), [this.sort.column['sortKey']], [this.sort.order]);
      return;
    }

    if (!column && this.sort.column === '') {
      column = this.columns[1];
      const secondaryColumn = this.columns[2];
  
      this.teams = _.orderBy(
        [].concat(this.teams || []), 
        [column.sortKey, secondaryColumn.sortKey], // Primary and secondary keys
        ['asc', 'asc'] // Default orders for primary and secondary keys
      );
      return;
    } else if (!column) {
      column = this.sort.column;
    }
    if (column.sortable) {
      let order = 'asc';
      if (this.sort.column !== column) {
        order = 'asc';
      } else {
        order = this.sort.order === 'asc' ? 'desc' : 'asc';
      }
      this.sort = {
        column: column,
        order: order
      };
      this.columns.forEach(c => c.order = null);
      column.order = order;
      this.teams = _.orderBy([].concat(this.teams || []), [column.sortKey], [order]);
    }
  }

  canSaveNewTeam() {
    return !this.formGroup.invalid;
  }

  canMovePortofolio() {
    return !this.formGroupMovePortofolio.invalid;
  }

  editTeam(team) {
    const teamMembers = this.users.filter(u => {
      return team.members.some(m => m.user_id === u.user_id);
    }).map(u => u.user_id);
    this.initForm(team, teamMembers);
    team.isInEditMode = true;
    this.isOneLineInEditMode = true;
  }

  cancelEditTeam(team) {
    this.initForm({}, []);
    team.isInEditMode = false;
    this.isOneLineInEditMode = false;
  }

  saveTeam(team) {
    if (!this.formGroup.invalid) {
      const formData = this.formGroup.getRawValue();
      const user = this.users.find(u => u.user_id === formData.leader);
      formData.lead = formData.leader;
      formData.mem = formData.members.join(',');
      formData.usersMembers = formData.members.map(m => {
        const findUser = this.users.find(u => u.user_id === m);
        return findUser;
      });

      formData.membersName = formData.usersMembers.map(m => m.fullname).join(', ');
      formData.members = formData.usersMembers.map(m => { return m  });
      formData.leaderName = user ? user.fullname : '';
      formData.search = `${formData.name} ${formData.leaderName} ${formData.membersName}`;
      formData.isconta = formData.isconta ? '1' : '0';
      formData.isIt = formData.isit ? '1' : '0';
      formData.departament = formData.departament;

      if (!formData.id) {
        this.store.dispatch(TeamAddRequested({ formData, userId: this.userId, users: this.users }));
      } else {
        this.store.dispatch(TeamUpdateRequested({ formData, userId: this.userId, users: this.users }));
        team.isInEditMode = false;
        team.mem = this.getTeamMem(team.usersMembers);
        this.newMembers = this.getNewMembersInTeam(team, formData);
      }
    }
  }

  deleteTeam(team: any) {
    this.dialogService
      .open(ConfirmActionModalComponent, {
        context: {
          title: 'ATENȚIE',
          description: `Esti sigur ca doresti sa stergi echipa: ${team.name}?`,
          withConsent: true
        }
      })
      .onClose.subscribe((res: any) => {
        if (res) {
          this.store.dispatch(TeamDeleteRequested({ teamId: team.id }));
          this.teams = this.teams.filter(p => p.id !== team.id);
        }
      });
  }

  updateCoordinatorForClients(formData, team) {
    const coordinatorId = formData.leader;
    const teamId = team.id;

    this.newMembers.forEach(memberId => {
      if (this.memberBelongsToOnlyOneTeam(memberId, formData)) {
        this.getClientsForMember(teamId, memberId, coordinatorId);
      }
    });
  }

  getNewMembersInTeam(team, formData) {
    const newMembers: any = [];

    formData.members.forEach(memberId => {
      if (!team.mem.includes(memberId)) {
        newMembers.push(memberId);
      }
    });

    return newMembers;
  }

  getClientsForMember(teamId, userId, coordinatorId) {
    const data = this.clientService.getAllClientsWithoutAdministrative('');
    data.subscribe((clientsResponse: any) => {
      let clients = clientsResponse.clients.filter(c => c.client_is_administrative === '0' && c.responsible_user_id === userId).map(client => {
        client.responsible_team_id = teamId;
        return client;
      });
      this.setTeamForClients(clients, teamId);
    });
  }

  memberBelongsToOnlyOneTeam(userId, formData) {
    let count = 0;
    this.teams.forEach(team => {
      team.members.forEach(member => {
        if (member.user_id === userId) {
          count++;
        }
      });
      if (count > 1) {
        return false;
      }
    });

    //special case: for modified team, team.members contains only the IDs, not objects
    if (count === 1) {
      formData.members.forEach(memberId => {
        if (memberId === userId) {
          count++;
        }
      });
      if (count > 1) {
        return false;
      }
    }

    return true;
  }

  getTeamsMem() {
    this.teams.forEach(team => {
      const mem = [];
      team.members.forEach(member => {
        mem.push(member.user_id + ',');
      });
      team.mem = mem;
    });

    this.teams.forEach(team => {
    });
  }

  getTeamMem(members) {
    let mem = '';
    members.forEach(member => {
      mem += member.user_id + ',';
    });

    return mem;
  }

  setTeamForClients(clients, teamId) {
    this.clientService.setTeamId(clients, teamId)
      .subscribe((response: any) => {
      });
  }

  exportTable() {
    let table;
    table = _.sortBy(this.teams.map(orc => {
      return {
        client: orc.client_name,
        numarInregistrareDosar: orc.registration_number,
        dataAdmitere: orc.admission_date ? moment(parseFloat(orc.admission_date) - 1000).format('DD.MM.YYYY') : '',
        commission: orc.commission,
        obiectulCererii: orc.objective,
        stadiulCererii: orc.statusName,
        observatii: orc.observations,
        dataDosar: moment(parseFloat(orc.date) - 1000).format('DD.MM.YYYY'),
        numarInregistrare: orc.client_registration_number,
        administrator: orc.client_administrators,
        telefon: orc.client_phone,
        sumaIncasata: orc.amount,
        dataIncasarii: orc.amount_date ? moment(parseFloat(orc.amount_date) - 1000).format('DD.MM.YYYY') : ''
      };
    }), ['date']);

    this.excelService.exportAsExcelFile(table, `Export dosare orc ${this.month}.${this.year}`);
  }

  setStatusFilter($event) {
    this.filtersEnabled = true;
    this.filter.status = $event;
    this.getTeams();
  }

  updateEndInterval($event) {
    this.filtersEnabled = true;
    this.endtimeInterval = $event;
    this.getTeams(true);
  }

  updateStartInterval($event) {
    this.filtersEnabled = true;
    this.starttimeInterval = $event;
    this.getTeams(true);
  }

  showMovePortofolio() {
    this.isMovePortofolioActivated = true;
    this.initFormMovePortofolio();
  }

  movePortofolio() {
    const formData = this.formGroupMovePortofolio.getRawValue();
    this.dialogService
      .open(ConfirmActionModalComponent, {
        context: {
          title: 'ATENȚIE',
          description: `Esti sigur ca doresti sa muti portofoliul intre clientii selectati?`,
          withConsent: false
        }
      })
      .onClose.subscribe((res: any) => {
        if (res) {
          this.userService.movePortofolio(formData.userFrom, formData.userTo)
            .subscribe((response: any) => {
              if (response !== null) {
                this.toastrService.show('', 'Portofoliul a fost mutat cu succes!', ToastrConfigs.success);
              }
            },
              () => {
                this.toastrService.show('', 'Portofoliul nu a fost mutat!', ToastrConfigs.danger);
              });
        }
      });

    this.initFormMovePortofolio();
    this.isMovePortofolioActivated = false;
  }

  dismiss() {
    this.isMovePortofolioActivated = false;
  }
}

export enum AsconActions {
  ViewAllClients,
  ViewMyClients,
  ViewTeamClients,
  UpdateClients,
  DeleteClients,
  RegisterClients,
  ViewSensitiveClientData,
  UpdateSensitiveClientData,
  ViewWorksheets,
  UpdateVectorWorksheet,
  SetTemplateToWorksheet,
  ViewConta1Worksheet,
  UpdateConta1Worksheet,
  ViewConta2Worksheet,
  UpdateConta2Worksheet,
  ViewWorksheetReport,
  ViewClientsIndicators,
  ViewHrLedger,
  ViewTeams,
  RegisterTeam,
  UpdateTeam,
  DeleteTeam,
  ViewUsers,
  RegisterUser,
  UpdateUser,
  DeleteUser,
  ViewTasks,
  RegisterTask,
  UpdateTask,
  DeleteTask,
  ViewTemplates,
  RegisterTemplate,
  UpdateTemplate,
  DeleteTemplate,
  ViewFgoImport,
  ViewPayTypes,
  ViewSagaDbFileConvertor,
  ViewBringoUtil,
  ViewCovidClients,
  ViewPayments,
  ViewIncomes,
  ViewSagaIncomes,
  ViewInstitutionIssues,
  RegisterInstitutionIssue,
  DeleteInstitutionIssue,
  UpdateInstitutionIssue,
  FinalizeInstitutionIssue,
  ViewOrcs,
  RegisterOrc,
  DeleteOrc,
  UpdateOrc,
  ViewDocumentGenerator,
  AddDocumentTemplate,
  UpdateDocumentTemplate,
  DeleteDocumentTemplate,
  DeleteTaskFromWorksheet,
  UpdateLog,
  CanSendDeclaration,
  CanViewSensitiveDataOrc,
  UserPortofolio,
  ViewEmployees,
  ResetTemplateToWorksheet,
  PeriodicalVerification,
  ViewImportClientsUtil,
  Clients_ViewAllClients,
  Clients_ViewMyClients,
  Clients_ViewTeamClients,
  ViewRentability,
  ViewNormalIncomes,
  ViewIncomeTypes,
  ViewSold,
  FinancialReport,
  Tarifs,
  ViewWorksheetsHr,
  ViewHrWorksheet,
  UpdateHrWorksheet,
  ViewHrNumbers,
  ViewWorkProcedures,
  EditWorkProcedures,
  EmailOnrc,
  ViewClientContracts,
  RegisterClientContracts,
  DeleteClientContracts,
  UpdateClientContracts,
  ViewInvoices,
  RegisterInvoice,
  UpdateInvoice,
  DeleteInvoice,
  Invoices_ViewAllClients,
  Invoices_ViewMyClients,
  Invoices_ViewTeamClients,
  SendInvoice,
  ViewCalculator,
  ViewFmiuPayments,
  ViewFmiuPaymentCategories,
  ViewFmiuIncomesCategories,
  ViewAsconSalaries,
  ViewAsconDashboard,
  ViewAsconBalanceWidgets,
  ViewAsconTicheteWidgets,
  ViewAllHolidays,
  ViewClientsWidgets,
  ViewManagementReport,
  Send473Email,
  DeleteCompanies,
  UpdateCompanies,
  RegisterCompanies,
  ViewCompanies,
  ViewEuropeanFonds,
  RegisterEuropeanFonds,
  UpdateEuropeanFonds,
  DeleteEuropeanFonds,
  ViewIbanRegions,
  RegisterIbanRegion,
  UpdateIbanRegion,
  DeleteIbanRegion,
  View473ProblemsWidgets,
  ViewSensitiveDataContracts,
  ViewCompanyInvoices,
  RegisterCompanyInvoice,
  UpdateCompanyInvoice,
  DeleteCompanyInvoice,
  ViewInactiveClientsWidget,
  ViewTaxesStatus,
  CanInitializeCompanyProfile,
  ViewAdminVerification,
  ViewAllContaTicketsWidget,
  ViewContaTicketsWidget,
  ViewWorksheetSummaryWidget,
  GenerateAnafToken,
  ViewSupportTickets,
  ViewAllClientsPayrolls,
  ViewMyClientsPayrolls,
  ViewTeamClientsPayrolls,
  UploadPayrolls,
  ViewAllSupportTickets,
  AddSupportTickets,
  EditSupportTickets,
  DeleteSupportTickets,
  CanBlockAccess,
  CanRequestSagaUpdate,
  CanViewAccountRecords,
  CanViewUnpaidInvoices,
  CanViewEmailNotifications,
  CanEditEmailNotifications,
  CanDeleteEmailNotifications,
  ViewVatStatus,
  ViewSensitiveUserData,
  UpdateSensitiveUserData,
  ImportBankStatements,
  ViewConvertorBtPaymentsUtil,
  ViewClientPlans,
  ViewWorkStatus,
  View5125ProblemsWidgets,
  ViewTichetStats,
  ManageManuals
}

export enum AsconActionsLabel {
  ViewAllClients = 'Vizualizare toti clientii',
  ViewMyClients = 'Vizualizare clienti proprii',
  ViewTeamClients = 'Vizualizare clienti echipa',
  UpdateClients = 'Modificare date clienti',
  DeleteClients = 'Stergere clienti',
  RegisterClients = 'Adaugare client nou',
  ViewSensitiveClientData = 'Vizualizare data sensibile client',
  UpdateSensitiveClientData = 'Modificare date sensibile client',
  ViewWorksheets = 'Vizualizare fise de lucru',
  UpdateVectorWorksheet = 'Modificare fisa de lucru',
  SetTemplateToWorksheet = 'Setare template fisa de lucru',
  ViewConta1Worksheet = 'Vizualizare conta1 fisa de lucru',
  UpdateConta1Worksheet = 'Modificare conta1 fisa de lucru',
  ViewConta2Worksheet = 'Vizualizare conta2 fisa de lucru',
  UpdateConta2Worksheet = 'Modificare conta2 fisa de lucru',
  ViewWorksheetReport = 'Vizualizare raport fisa de lucru',
  ViewClientsIndicators = 'Vizualizare indicatori clienti',
  ViewHrLedger = 'Vizualizare Registru HR',
  ViewTeams = 'Vizualizare echipe',
  RegisterTeam = 'Adaugare echipa',
  UpdateTeam = 'Modificare echipa',
  DeleteTeam = 'Stergere echipa',
  ViewUsers = 'Vizualizare utilizatori',
  RegisterUser = 'Adaugare utilizator',
  UpdateUser = 'Modificare utilizator',
  DeleteUser = 'Stergere utilizator',
  ViewTasks = 'Vizualizare taskuri',
  RegisterTask = 'Adaugare task',
  UpdateTask = 'Modificare task',
  DeleteTask = 'Stergere task',
  ViewTemplates = 'Vizualizare templateuri taskuri',
  RegisterTemplate = 'Adaugare template taskuri',
  UpdateTemplate = 'Modificare template taskuri',
  DeleteTemplate = 'Stergere template taskuri',
  ViewFgoImport = 'Import FGO',
  ViewPayTypes = 'Vizualizare categorii plati',
  ViewSagaDbFileConvertor = 'Vizualizare Saga DBFile Convertor',
  ViewBringoUtil = 'Convertor Bringo/Avize Naomi',
  ViewCovidClients = 'Vizualizare COVID clienti',
  ViewPayments = 'Vizualizare plati',
  ViewIncomes = 'Vizualizare incasari',
  ViewSagaIncomes = 'Vizualizare solduri clienti',
  ViewInstitutionIssues = 'Vizualizare probleme institutii',
  RegisterInstitutionIssue = 'Adaugare problema institutie',
  DeleteInstitutionIssue = 'Stergere problema institutie',
  UpdateInstitutionIssue = 'Modificare problema institutie',
  FinalizeInstitutionIssue = 'Finalizare problema institutie',
  ViewOrcs = 'Vizualizare ORC',
  RegisterOrc = 'Adaugare dosar ORC',
  DeleteOrc = 'Stergere dosar ORC',
  UpdateOrc = 'Modificare dosar ORC',
  ViewDocumentGenerator = 'Vizualizare generator documente',
  AddDocumentTemplate = 'Adaugare template document',
  UpdateDocumentTemplate = 'Modificare template document',
  DeleteDocumentTemplate = 'Stergere template document',
  DeleteTaskFromWorksheet = 'Stergere task din fisa de lucru',
  UpdateLog = 'Modificare log de lucru',
  CanSendDeclaration = 'Poate trimite declaratii',
  CanViewSensitiveDataOrc = 'Modificare sume incasate ORC',
  UserPortofolio = 'Portofoliu echipa',
  ViewEmployees = 'Vizualizare angajati',
  ResetTemplateToWorksheet = 'Resetare template fisa de lucru',
  PeriodicalVerification = 'Verificare periodica si analiza',
  ViewImportClientsUtil = 'Import clienti listafirme.ro',
  Clients_ViewAllClients = 'Meniu clienti: Vizualizare clienti',
  Clients_ViewMyClients = 'Meniu clienti: Vizualizare clienti proprii',
  Clients_ViewTeamClients = 'Meniu clienti: Vizualizare clienti echipa',
  ViewRentability = 'Vizualizare rentabilitate',
  ViewNormalIncomes = 'Vizualizare incasari diverse',
  ViewIncomeTypes = 'Vizualizare catergorii incasari',
  ViewSold = 'Registru incasari plati',
  FinancialReport = 'Raport financiar',
  Tarifs = 'Parametrii tarif',
  ViewWorksheetsHr = 'Vizualizare fise de lucru HR',
  ViewHrWorksheet = 'Vizualizare hr fisa de lucru',
  UpdateHrWorksheet = 'Modificare conta2 fisa de lucru',
  ViewHrNumbers = 'Vizualizare numere inregistrare',
  ViewWorkProcedures = 'Vizualizare proceduri de lucru',
  EditWorkProcedures = 'Editare proceduri de lucru',
  EmailOnrc = 'Email dosare ONRC',
  ViewClientContracts = 'Vizualizare contracte clienti',
  RegisterClientContracts = 'Adaugare contracte clienti',
  DeleteClientContracts = 'Stergere contracte clienti',
  UpdateClientContracts = 'Modificare contracte clienti',
  ViewInvoices = 'Vizualizare facturi',
  RegisterInvoice = 'Adaugare factura',
  UpdateInvoice = 'Modificare factura',
  DeleteInvoice = 'Stergere factura',
  Invoices_ViewAllClients = 'Menu Facturi: Vizualizare toate facturile',
  Invoices_ViewMyClients = 'Menu Facturi: Vizualizare facturi clienti proprii',
  Invoices_ViewTeamClients = 'Menu Facturi: Vizualizare facturi clienti echipa',
  SendInvoice = 'Trimitere factura catre client pe email',
  ViewCalculator = 'Vizualizare calculator grila',
  ViewFmiuPayments = 'FMIU Raport incasari plati',
  ViewFmiuPaymentCategories = 'FMIU Categorii plati',
  ViewFmiuIncomesCategories = 'FMIU Categorii incasari',
  ViewAsconSalaries = 'Vizualizare salarii Ascon',
  ViewAsconDashboard = 'Vizualizeaza dashboard Ascon',
  ViewAsconBalanceWidgets = 'Vizualizeaza widget solduri Ascon',
  ViewAsconTicheteWidgets = 'Vizualizeaza widget tichete de masa',
  ViewAllHolidays = 'Vizualizare toate concediile',
  ViewClientsWidgets = 'Vizualizare widgeturi clienti',
  ViewManagementReport = 'Vizualizare raport de management',
  Send473Email = 'Trimite email 473',
  DeleteCompanies = 'Stergere companii',
  UpdateCompanies = 'Modificare date companii',
  RegisterCompanies = 'Adaugare companie noua',
  ViewCompanies = "Vizualizare companii",
  ViewEuropeanFonds = "Vizualizare fonduri europene",
  RegisterEuropeanFonds = "Adaugare fonduri europene",
  UpdateEuropeanFonds = "Modificare fonduri europene",
  DeleteEuropeanFonds = "Stergere fonduri europene",
  ViewIbanRegions = 'Vizualizare regiuni IBAN',
  RegisterIbanRegion = 'Adaugare regiune IBAN',
  UpdateIbanRegion = 'Modificare regiune IBAN',
  DeleteIbanRegion = 'Stergere regiune IBAN',
  View473ProblemsWidgets = "Vizualizare widget probleme 473",
  ViewSensitiveDataContracts = "Vizualizare date sensibile contract",
  ViewCompanyInvoices = 'Vizualizare facturi companii',
  RegisterCompanyInvoice = 'Adaugare factura pentru companie',
  UpdateCompanyInvoice = 'Modifica factura companiei',
  DeleteCompanyInvoice = 'Sterge factura companiei',
  ViewInactiveClientsWidget = "Vizualizare widget clienti inactivi",
  ViewTaxesStatus = "Vizualizare status taxe",
  CanInitializeCompanyProfile = 'Initiere cont companie',
  ViewAdminVerification = 'Vizualizare verificari admin',
  ViewAllContaTicketsWidget = 'Vizualizare widget toate tichetele de conta',
  ViewContaTicketsWidget = 'Vizualizare widget tichete de conta',
  ViewWorksheetSummaryWidget = 'Vizualizare widget stadiul lucrarilor',
  GenerateAnafToken = 'Generare token ANAF',
  ViewSupportTickets = "Vizualizare Tichete IT",
  ViewAllClientsPayrolls = 'Vizualizare stat de plata toti clientii',
  ViewMyClientsPayrolls = 'Vizualizare stat de plata clienti proprii',
  ViewTeamClientsPayrolls = 'Vizualizare stat de plata clienti echipa',
  UploadPayrolls = 'Incarcare stat de plata',
  ViewAllSupportTickets = "Vizualizare toate Tichete IT",
  AddSupportTickets = "Crearea Tichete IT",
  EditSupportTickets = "Modifica Tichete IT",
  DeleteSupportTickets = "Sterge Tichete IT",
  CanBlockAccess = "Blocarea acces in APP Client",
  CanRequestSagaUpdate = "Cerere de actualizare SAGA",
  CanViewAccountRecords = "Vizualizare Fisa de conturi",
  CanViewUnpaidInvoices = "Vizualizare Restanțe clienți",
  CanViewEmailNotifications = "Vizualizare notificari email",
  CanEditEmailNotifications = "Modifica notificari email",
  CanDeleteEmailNotifications = "Sterge notificari email",
  ViewVatStatus = "Vizualizare status TVA",
  ViewSensitiveUserData = "Vizualizare informații confidențiale utilizatori",
  UpdateSensitiveUserData = "Modifică informații confidențiale utilizatori",
  ImportBankStatements = "Import statement bancar",
  ViewConvertorBtPaymentsUtil = "Vizualizare Convertor plăți BT",
  ViewClientPlans = "Vizualizare Abonamente clienți",
  ViewWorkStatus = "Vizuealizare Stadiul lucrarilor",
  View5125ProblemsWidgets = "Vizualizare widget probleme 5125",
  ViewTichetStats = "Vizualiazare statistici tichete",
  ManageManuals = 'Gestionare ghiduri',
}
